"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InmateSource = exports.appendSearchParams = exports.SDK = void 0;
const axios_1 = require("axios");
const endpoints = require("./endpoints");
const models = require("@lantern/models");
class SDK {
    static get instance() {
        if (!SDK._instance)
            SDK._instance = new SDK();
        return SDK._instance;
    }
    constructor() {
        this.endpoints = endpoints;
    }
    set token(token) {
        this._token = token;
        SDK.axios.defaults.headers.authorization = this._token;
    }
    set permissionToken(permissionToken) {
        this._permissionToken = permissionToken;
        SDK.axios.defaults.headers['permission-token'] = this._permissionToken;
    }
    get permissionToken() {
        return this._permissionToken;
    }
    set host(host) {
        this._baseUrl = new URL('/v1', host);
        SDK.axios.defaults.baseURL = this._baseUrl.href;
    }
    setTokenRefreshFn(refresh, waitForRefresh) {
        SDK.axios.interceptors.request.use(waitForRefresh);
        SDK.axios.interceptors.response.use(undefined, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            console.log(`SDK refresh attempt`);
            // Called on any Axios request error
            if (error.config && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                console.log({ error });
                // Token expired, attempt to refresh token
                try {
                    const { accessToken, permissionToken } = yield refresh();
                    this.token = accessToken;
                    this.permissionToken = permissionToken;
                    // eslint-disable-next-line require-atomic-updates
                    error.config.headers.authorization = accessToken;
                    // eslint-disable-next-line require-atomic-updates
                    error.config.headers['permission-token'] = permissionToken;
                    return SDK.axios.request(error.config);
                }
                catch (err) {
                    console.error('Failed to refresh token.');
                    throw error;
                }
            }
            else {
                throw error;
            }
        }));
    }
}
exports.SDK = SDK;
SDK.axios = axios_1.default.create();
function appendSearchParams(url, options) {
    if (options) {
        const searchParams = new URLSearchParams();
        Object.entries(options).forEach(key => {
            if (key[1] !== undefined)
                searchParams.append(key[0], key[1].toString());
        });
        return `${url}?${searchParams.toString()}`;
    }
    return url;
}
exports.appendSearchParams = appendSearchParams;
exports.InmateSource = models.InmateSource;
//# sourceMappingURL=sdk.js.map